import { render } from "./AccessUserList.vue?vue&type=template&id=767efeb2"
import script from "./AccessUserList.vue?vue&type=script&lang=js"
export * from "./AccessUserList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__